(ns manage.adset-decision-tree-page.view.side-panel.feed.core
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/List$default" :as List]
            ["@mui/material/ListItem$default" :as ListItem]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/ToggleButton$default" :as ToggleButton]
            ["@mui/material/ToggleButtonGroup$default" :as ToggleButtonGroup]
            ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj]]
            [common.form :as form]
            [common.queries :refer [invalidate-queries use-query]]
            [common.resource.query.adset :refer [adset-query]]
            [common.resource.query.feed :refer [unique-values-query]]
            [common.resource.query.schema :refer [schemas-output-structure-query]]
            [common.widgets.form-field :refer [form-field]]
            [manage.adset-decision-tree-page.event :as event]
            [manage.adset-decision-tree-page.schema-urn :as schema-urn]
            [manage.adset-decision-tree-page.sub :as sub]
            [manage.adset-decision-tree-page.view.side-panel.feed.converter
             :as converter]
            [manage.adset-decision-tree-page.view.side-panel.feed.selector
             :refer [feed-selector selected-feed]]
            [manage.adset-decision-tree-page.view.side-panel.property-form
             :refer [get-property-field-name
                     get-save-patch-data
                     use-set-value-for-field-name]]
            [manage.adset-decision-tree-page.view.side-panel.util
             :as side-panel.util]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defhook defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui save-button [{{:keys [handleSubmit]} :form-control
                     :keys [property selected-node]}]
  (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        decision-tree-id (use-subscribe [::sub/decision-tree-id])
        on-success (fn []
                     (invalidate-queries
                      {:queryKey ["decision-tree" advertiser-id adset-id decision-tree-id]}))
        on-submit
        (handleSubmit
         (fn [data]
           (when-let [{:keys [node-id patch-key patch-data]} (get-save-patch-data
                                                              {:property property
                                                               :new-form-data (->clj data)
                                                               :selected-node selected-node})]
             (rf/dispatch
              [::event/be-patch-node node-id {patch-key patch-data} on-success]))))]
    ($ Button
       {:variant "contained"
        :color "grey"
        :sx #js {:maxWidth "fit-content"
                 :alignSelf "end"}
        :onClick on-submit}
       "Save")))

(defui exact-match-input-group
  [{{:keys [control resetField]} :form-control
    :keys [get-field-name column-options feed-id]}]
  (let [column-field-name (get-field-name :to)
        selected-column (rhf/useWatch #js {:name column-field-name :control control})
        {:keys [advertiser-id]} (use-subscribe [:url-context])
        {:keys [data isFetching]} (use-query (unique-values-query
                                              {:advertiser-id advertiser-id
                                               :feed-importer-id feed-id
                                               :column-name selected-column}))
        value-options (uix/use-memo
                       #(map (fn [label]
                               {:label label
                                :value (str label)})
                             data)
                       [data])
        value-field-name (get-field-name :from :param :value)]
    ($ :<>
       ($ form/autocomplete-field
          {:name column-field-name
           :control control
           :label "Lookup column"
           :field-props (assoc column-options :size "small")
           :on-after-change #(resetField value-field-name #js {:defaultValue nil})})
       ($ form/autocomplete-field
          {:name value-field-name
           :control control
           :label "Value"
           :field-props {:size "small"
                         :options value-options
                         :loading (not isFetching)}}))))

(defhook use-schema-structure-options [{:keys [query-args value-fn]
                                        :or {value-fn identity}}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {:keys [data isFetching]} (use-query (schemas-output-structure-query
                                              (merge {:advertiser-id advertiser-id}
                                                     query-args)))]

    (uix/use-memo (fn []
                    {:options (map (fn [[k {:keys [label]}]]
                                     {:label label
                                      :value (value-fn (name k))})
                                   data)
                     :loading isFetching})
                  [data isFetching value-fn])))

(defn add-macro-brackets [macro-name] (str "${" macro-name "}"))

(defn add-options-group [options group]
  (update options :options (fn [options]
                             (map #(assoc % :group group) options))))

(defui macro-input-group
  [{:keys [get-field-name form-control column-options]}]
  (let [dsp-macro-options (-> (use-schema-structure-options
                               {:query-args {:schema-id schema-urn/dsp-data}
                                :value-fn add-macro-brackets})
                              (add-options-group "DSP Macros"))
        location-options (-> (use-schema-structure-options
                              {:query-args {:schema-id schema-urn/location}})
                             (add-options-group "IP to Geo"))

        macro-options (uix/use-memo (fn []
                                      {:options (concat (:options location-options)
                                                        (:options dsp-macro-options))
                                       :loading (or (:loading dsp-macro-options)
                                                    (:loading location-options))})
                                    [dsp-macro-options location-options])]
    ($ :<>
       ($ form/autocomplete-field
          {:name (get-field-name :to)
           :control (:control form-control)
           :label "Lookup column"
           :field-props (assoc column-options :size "small")})
       ($ form/autocomplete-field
          {:name (get-field-name :from :param 0 :dsp-macro)
           :control (:control form-control)
           :label "Macro name"
           :field-props (assoc macro-options
                               :size "small"
                               :group-by (fn [^js option]
                                           (.-group option)))}))))

(defui feed-input-group-item
  [{:keys [get-field-name form-control disabled-input-types] :as props}]
  (let [field (->clj (rhf/useWatch #js {:name (get-field-name)
                                        :control (:control form-control)}))
        current-tab-key (converter/get-feed-input-type field)
        set-item-value (use-set-value-for-field-name form-control (get-field-name))]
    ($ side-panel.util/condition-group-item (select-keys props
                                                         [:on-delete :label :delete-disabled])
       ($ Stack {:spacing 1}
          ($ ToggleButtonGroup
             {:value current-tab-key
              :exclusive true
              :disabled (:disabled props)
              :size "small"
              :onChange (fn [_ new-value]
                          (when new-value
                            (set-item-value (if (= new-value "macro")
                                              (clj->js converter/macro-input-from)
                                              (clj->js converter/exact-match-from)))))}
             ($ ToggleButton
                {:value "exact-match"
                 :disabled (contains? disabled-input-types "exact-match")}
                "Exact match")
             ($ ToggleButton
                {:value "macro"
                 :disabled (contains? disabled-input-types "macro")}
                "Macro"))
          (case current-tab-key
            "exact-match" ($ exact-match-input-group props)
            "macro" ($ macro-input-group props))))))

(defui value-column
  [{:keys [field-name control column-options]}]
  ($ form-field {:label "Targeting column"}
     ($ form/autocomplete-field
        {:name field-name
         :control control
         :field-props (assoc column-options :size "small")})))

(defui feed-input [{:keys [form-control property disabled] :as props}]
  (let [{:keys [adset-id]} (use-subscribe [:url-context])
        {{:keys [channel]} :data} (use-query (adset-query {:adset-id adset-id}))

        get-field-name (partial get-property-field-name property 0 :param :data :in)
        {:keys [fields append remove]} (form/use-field-array
                                        #js {:control (:control form-control)
                                             :name (get-field-name)})
        item-base-props (select-keys props [:form-control :column-options :disabled :feed-id])

        disabled-input-types (cond-> #{}
                               (= "meta" channel) (conj "macro"))]
    ($ List
       (map-indexed
        (fn [index ^js field]
          ($ feed-input-group-item
             (merge item-base-props
                    {:key (.-id field)
                     :label (if (zero? index) "if" "and")
                     :get-field-name (partial get-field-name index)
                     :delete-disabled (or disabled (<= (count fields) 1))
                     :on-delete (partial remove index)
                     :disabled-input-types disabled-input-types})))

        (or (seq fields) [#js {:id "inititial"}]))
       (when-not disabled
         ($ ListItem
            ($ Button {:startIcon ($ Icon "add")
                       :variant "text"
                       :on-click (partial append (clj->js converter/exact-match-from))}
               "Add input column"))))))

(defui feed-properties [{{:keys [control]} :form-control
                         :keys [form-control property feed-select-type sx] :as props
                         :or {feed-select-type :modal}}]
  (let [feed-id-field-name (get-property-field-name property 0 :param :feed-id)
        feed-id (rhf/useWatch #js {:name feed-id-field-name :control control})
        disabled (.-disabled (:formState form-control))
        column-options (use-schema-structure-options {:query-args
                                                      {:schema-id schema-urn/feed
                                                       :param {:feed-id feed-id}}})]
    ($ Stack {:spacing 1 :sx sx}
       ($ feed-selector {:field-name feed-id-field-name
                         :form-control form-control
                         :view-type feed-select-type
                         :reset-fields [(get-property-field-name property 0 :param :data)
                                        (get-property-field-name property 0 :value-column)]})
       (when (some? feed-id)
         ($ :<>
            ($ feed-input {:feed-id feed-id
                           :form-control form-control
                           :disabled disabled
                           :property property
                           :column-options column-options})
            ($ value-column {:control control
                             :column-options column-options
                             :field-name (get-property-field-name property 0 :value-column)})
            (when (and (:has-save-button property) (not disabled))
              ($ save-button props)))))))

(defui feed-outcome-source [{:keys [selected-item]}]
  (let [parent-node-id (:decision-node-id selected-item)
        parent-node (use-subscribe [::sub/node-data parent-node-id])
        feed-id (get-in parent-node [:targeting :context 0 :param :feed-id])]
    ($ selected-feed {:feed-id feed-id})))
